export enum GpFundsPageTabs {
  Fundraisings = 0,
  UnderManagement = 1,
  Canceled = 2,
  Draft = 3,
  Realized = 4
}
